"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5812],{

/***/ 108:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Oo": function() { return /* reexport */ Breadcrumbs; },
  "HQ": function() { return /* reexport */ icons/* CheckoutChevronIcon */.HQ; },
  "Ps": function() { return /* reexport */ GridItems; },
  "Ar": function() { return /* reexport */ layout/* Layout */.A; },
  "gb": function() { return /* reexport */ Loading; },
  "bF": function() { return /* reexport */ ViewMore; }
});

// UNUSED EXPORTS: AboutCard, AccountIcon, ArrowRight, AustraliaMapIcon, Banner, BookIcon, DogIcon, EmailIcon, LoadingSpinner, ModalComponent, PawIcon, RedHeartIcon, SearchIcon, ShoppingBagIcon, TeamIcon

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./src/components/common/about/AboutCard.tsx

var AboutCard = function(props) {
    var content = props.content;
    return /*#__PURE__*/ _jsx("div", {
        dangerouslySetInnerHTML: {
            __html: content
        }
    });
};

;// CONCATENATED MODULE: ./src/components/common/about/index.ts


// EXTERNAL MODULE: ./src/components/common/banner/index.tsx
var banner = __webpack_require__(1946);
// EXTERNAL MODULE: ./src/components/common/icons/index.ts + 9 modules
var icons = __webpack_require__(9257);
// EXTERNAL MODULE: ./src/components/common/layout/index.tsx + 13 modules
var layout = __webpack_require__(8969);
// EXTERNAL MODULE: ./node_modules/react-modal/lib/index.js
var lib = __webpack_require__(3253);
;// CONCATENATED MODULE: ./src/components/common/modal/Modal.tsx




/**
 * Renders the modal component.
 *
 * @param {ReactModal.Props} props - The props.
 * @returns {JSX.Element} - The HTML Markup.
 */ var ModalComponent = function(props) {
    var children = props.children, _className = props.className, className = _className === void 0 ? "" : _className, isOpen = props.isOpen, onRequestClose = props.onRequestClose;
    ReactModal.setAppElement("#__next");
    return /*#__PURE__*/ _jsx(ReactModal, _object_spread_props(_object_spread({}, props), {
        className: "".concat(className),
        isOpen: isOpen,
        onRequestClose: onRequestClose,
        shouldCloseOnOverlayClick: true,
        shouldCloseOnEsc: true,
        children: children
    }));
};

;// CONCATENATED MODULE: ./src/components/common/modal/index.ts


;// CONCATENATED MODULE: ./src/components/common/loading/Loading.tsx

var Loading = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "120",
        height: "30",
        viewBox: "0 0 120 30",
        xmlns: "http://www.w3.org/2000/svg",
        fill: "currentColor",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("circle", {
                cx: "15",
                cy: "15",
                r: "15",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("animate", {
                        attributeName: "r",
                        from: "15",
                        to: "15",
                        begin: "0s",
                        dur: "0.8s",
                        values: "15;9;15",
                        calcMode: "linear",
                        repeatCount: "indefinite"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("animate", {
                        attributeName: "fill-opacity",
                        from: "1",
                        to: "1",
                        begin: "0s",
                        dur: "0.8s",
                        values: "1;.5;1",
                        calcMode: "linear",
                        repeatCount: "indefinite"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("circle", {
                cx: "60",
                cy: "15",
                r: "9",
                fillOpacity: "0.3",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("animate", {
                        attributeName: "r",
                        from: "9",
                        to: "9",
                        begin: "0s",
                        dur: "0.8s",
                        values: "9;15;9",
                        calcMode: "linear",
                        repeatCount: "indefinite"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("animate", {
                        attributeName: "fill-opacity",
                        from: "0.5",
                        to: "0.5",
                        begin: "0s",
                        dur: "0.8s",
                        values: ".5;1;.5",
                        calcMode: "linear",
                        repeatCount: "indefinite"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("circle", {
                cx: "105",
                cy: "15",
                r: "15",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("animate", {
                        attributeName: "r",
                        from: "15",
                        to: "15",
                        begin: "0s",
                        dur: "0.8s",
                        values: "15;9;15",
                        calcMode: "linear",
                        repeatCount: "indefinite"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("animate", {
                        attributeName: "fill-opacity",
                        from: "1",
                        to: "1",
                        begin: "0s",
                        dur: "0.8s",
                        values: "1;.5;1",
                        calcMode: "linear",
                        repeatCount: "indefinite"
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/common/loading/index.ts


// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
;// CONCATENATED MODULE: ./src/components/common/breadcrumbs/index.tsx



var Breadcrumbs = function(param) {
    var _isAbsolute = param.isAbsolute, isAbsolute = _isAbsolute === void 0 ? false : _isAbsolute;
    var router = (0,next_router.useRouter)();
    var asPath = router.asPath;
    var paths = asPath.split("/");
    var breadcrumbPaths = paths.map(function(item, index) {
        if (item === "") {
            return {
                name: "Home",
                href: "/"
            };
        }
        var name = item.charAt(0).toUpperCase() + item.slice(1).replace(/-/g, " ");
        // capitalizes the first letter in every word
        var nameWithCapitalizedLetterAfterSpace = name.replace(/\s(.)/g, function($1) {
            return $1.toUpperCase();
        });
        var href = "".concat(paths.slice(0, index + 1).join("/"));
        return {
            name: nameWithCapitalizedLetterAfterSpace,
            href: href
        };
    });
    var defaultColors = {
        isActiveColor: "text-colorTen",
        normalColor: "text-colorFive"
    };
    var absoluteColors = {
        normalColor: "text-colorFifteen",
        isActiveColor: "text-colorTwelve"
    };
    var activeColors = isAbsolute ? absoluteColors : defaultColors;
    var breadcrumbItems = breadcrumbPaths.map(function(crumb, index) {
        var isCurrentCrumb = crumb.href === router.asPath;
        var isLastCrumb = index === breadcrumbPaths.length - 1;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "inline-block",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: crumb.href,
                    className: "".concat(isCurrentCrumb ? activeColors.isActiveColor : activeColors.normalColor, " ").concat(isLastCrumb ? "pointer-events-none" : "", " text-base"),
                    children: crumb.name
                }),
                !isLastCrumb && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "".concat(isCurrentCrumb ? activeColors.isActiveColor : activeColors.normalColor, " text-base"),
                    children: "\xa0>\xa0"
                })
            ]
        }, crumb.href);
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "z-10 py-8 ".concat(isAbsolute ? "absolute" : "static"),
        children: breadcrumbItems
    });
};

// EXTERNAL MODULE: ./src/ui/index.ts + 16 modules
var ui = __webpack_require__(4522);
;// CONCATENATED MODULE: ./src/components/common/view-more/index.tsx


var ViewMore = function(param) {
    var dataLength = param.dataLength, handleViewMoreClick = param.handleViewMoreClick, maxItemsLength = param.maxItemsLength, _buttonVariant = param.buttonVariant, buttonVariant = _buttonVariant === void 0 ? "primary" : _buttonVariant;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "h-full w-full text-center",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui/* ButtonWithArrow */.Ub, {
            onClick: handleViewMoreClick,
            buttonVariant: buttonVariant,
            center: true,
            children: [
                "View ",
                dataLength - maxItemsLength,
                " more"
            ]
        })
    });
};

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./src/components/common/grid/index.tsx




var GridItems = function(param) {
    var slicedData = param.slicedData, data = param.data, CardComponent = param.cardComponent;
    var handleViewMoreClick = function handleViewMoreClick() {
        setIsViewMoreClicked(true);
    };
    var ref = (0,react.useState)(false), isViewMoreClicked = ref[0], setIsViewMoreClicked = ref[1];
    var isProductCard = CardComponent.displayName === "ProductCard";
    var dataToMap = isViewMoreClicked ? data : slicedData;
    var CardLayout = isProductCard ? /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "grid grid-cols-1 gap-8 md:grid-cols-2 xl:grid-cols-3",
        children: dataToMap.map(function(d) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(CardComponent, {
                data: d,
                categoryHandle: d.categories[0].slug
            }, d.id);
        })
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "grid grid-cols-1 gap-8 rounded-b-lg px-8 md:grid-cols-3",
        children: dataToMap.map(function(d) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(CardComponent, {
                data: d
            }, d.id);
        })
    });
    if (!data.length) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "text-center",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Title */.Dx, {
                className: "text-colorFourteen",
                children: "No data found"
            })
        });
    }
    if (isViewMoreClicked) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: CardLayout
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            CardLayout,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "py-[60px]",
                children: isProductCard && data.length > 3 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ViewMore, {
                    handleViewMoreClick: handleViewMoreClick,
                    dataLength: data.length,
                    maxItemsLength: slicedData.length,
                    buttonVariant: "primary"
                }) : data.length > 5 && /*#__PURE__*/ (0,jsx_runtime.jsx)(ViewMore, {
                    handleViewMoreClick: handleViewMoreClick,
                    dataLength: data.length,
                    maxItemsLength: slicedData.length,
                    buttonVariant: "tertiary"
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/common/index.ts











/***/ }),

/***/ 4522:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "VD": function() { return /* reexport */ ApplyButton; },
  "e_": function() { return /* reexport */ BackgroundWrap; },
  "Ub": function() { return /* reexport */ ButtonWithArrow; },
  "Su": function() { return /* reexport */ CheckList; },
  "LX": function() { return /* reexport */ Cursive; },
  "kq": function() { return /* reexport */ CurveBanner; },
  "Mx": function() { return /* reexport */ GradientWrap; },
  "h4": function() { return /* reexport */ Header; },
  "ls": function() { return /* reexport */ HeroText; },
  "fb": function() { return /* reexport */ ImageWrapper; },
  "rJ": function() { return /* reexport */ InfoCard; },
  "_z": function() { return /* reexport */ PageContainer; },
  "xv": function() { return /* reexport */ Text; },
  "DU": function() { return /* reexport */ TextBold; },
  "Dx": function() { return /* reexport */ Title; },
  "im": function() { return /* reexport */ Wrapper; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./src/ui/background-wrapper.tsx

var BackgroundWrap = function(param) {
    var children = param.children, style = param.style, _className = param.className, className = _className === void 0 ? "" : _className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "desktop h-full w-full bg-cover bg-no-repeat  ".concat(className),
        style: style,
        children: children
    });
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(1799);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/solid/esm/ArrowRightIcon.js
var ArrowRightIcon = __webpack_require__(3519);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./src/ui/button-with-arrow.tsx




var ButtonWithArrow = function(param) {
    var children = param.children, href = param.href, onClick = param.onClick, _center = param.center, center = _center === void 0 ? false : _center, _className = param.className, className = _className === void 0 ? "" : _className, _containerSpanFull = param.containerSpanFull, containerSpanFull = _containerSpanFull === void 0 ? false : _containerSpanFull, _buttonVariant = param.buttonVariant, buttonVariant = _buttonVariant === void 0 ? "primary" : _buttonVariant, _buttonType = param.buttonType, buttonType = _buttonType === void 0 ? "button" : _buttonType, _buttonStyles = param.buttonStyles, buttonStyles = _buttonStyles === void 0 ? {} : _buttonStyles, _disabled = param.disabled, disabled = _disabled === void 0 ? false : _disabled, _fullWidth = param.fullWidth, fullWidth = _fullWidth === void 0 ? false : _fullWidth;
    var backgroundColor = {
        primary: "rgba(203, 153, 114, 1)",
        secondary: "transparent",
        tertiary: "rgba(255, 247, 240, 1)",
        fourth: "rgba(1, 64, 50, 1)",
        fifth: "rgba(134, 203,146, 1)"
    };
    var color = {
        primary: "rgba(255, 247, 240, 1)",
        secondary: "rgba(1, 64, 50, 1)",
        tertiary: "rgba(1, 64, 50, 1)",
        fourth: "rgba(255, 247, 240, 1)",
        fifth: "rgba(255, 247, 240, 1)"
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "w-full",
        style: {
            gridColumn: containerSpanFull ? "1/-1" : "auto",
            textAlign: center ? "center" : "left"
        },
        children: href ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
            href: href,
            className: "w-full py-4 text-left",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                onClick: onClick,
                type: buttonType,
                disabled: disabled,
                className: "flex items-center justify-between gap-2 rounded-lg py-3 px-5 text-lg font-bold transition duration-300 ease-in-out hover:shadow-ecPrimary-4 ".concat(className),
                // TODO: these styles could reference from var css variables
                style: (0,_object_spread/* default */.Z)({
                    backgroundColor: backgroundColor[buttonVariant],
                    color: color[buttonVariant],
                    margin: center ? "auto" : "0"
                }, buttonStyles),
                children: [
                    children,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowRightIcon/* default */.Z, {
                        width: "25px"
                    })
                ]
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
            onClick: onClick,
            type: buttonType,
            disabled: disabled,
            className: "flex items-center justify-between gap-2 rounded-lg py-3 px-5 text-lg font-bold transition duration-300 ease-in-out hover:shadow-ecPrimary-4 ".concat(className),
            // TODO: these styles could reference from var css variables
            style: (0,_object_spread/* default */.Z)({
                backgroundColor: backgroundColor[buttonVariant],
                color: color[buttonVariant],
                margin: center ? "auto" : "0",
                width: "100%",
                maxWidth: fullWidth ? "100%" : "240px"
            }, buttonStyles),
            children: [
                children,
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowRightIcon/* default */.Z, {
                    width: "25px"
                })
            ]
        })
    });
} // export const ButtonWithArrowRef = forwardRef<HTMLDivElement, ButtonWithArrowProps>((props, ref) => {
 //   return <ButtonWithArrow {...props} ref={ref} />
 // })
 // ButtonWithArrowRef.displayName = 'ButtonWithArrowRef'
;

;// CONCATENATED MODULE: ./src/ui/checklist.tsx

var CheckList = function(param) {
    var title = param.title, _className = param.className, className = _className === void 0 ? "" : _className;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex justify-start gap-4 ".concat(className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex items-center justify-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: "/assets/icons/checklist.svg",
                    alt: "checklist",
                    className: "h-5 w-5 lg:h-6 lg:w-6"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "font-haboro-soft text-lg text-colorFifteen lg:text-list ".concat(className),
                children: title
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/ui/cursive.tsx

var Cursive = function(param) {
    var children = param.children, _className = param.className, className = _className === void 0 ? "" : _className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "m-auto font-madelyn text-sliderTitle text-colorSixteen lg:text-bigHeader ".concat(className),
        children: children
    });
};

;// CONCATENATED MODULE: ./src/ui/curveBanner.tsx

var CurveBanner = function(param) {
    var children = param.children, _className = param.className, className = _className === void 0 ? "" : _className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "h-full w-full",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "curve absolute mt-[-1px] h-[550px] w-full bg-colorFifteen bg-no-repeat object-cover py-12 ".concat(className),
            children: [
                children,
                /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                    width: "1440",
                    height: "210",
                    viewBox: "0 0 1440 210",
                    stroke: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    className: "h-full w-full",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                        id: "clip",
                        clipPathUnits: "objectBoundingBox",
                        transform: "scale(0.000694444444444, 0.001680672268908)",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M0,0 L1440.01025,0 C1440.01025,76 1440.01025,114 1440.01025,114 C952.800926,113.708648 593.552979,210 0,210 C0,210 0,140 0,0 Z"
                        })
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/ui/gradient-wrapper.tsx

var GradientWrap = function(param) {
    var children = param.children, _className = param.className, className = _className === void 0 ? "" : _className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "h-full w-full bg-gradient-to-r ".concat(className),
        children: children
    });
} // put gradient path: from-colorxxx via-colorxxx to-xxx
 // color with opacity: from-colorxxx/number e.g. from-colorxxx/0.5
 // colorxxx/0.8  and colorxxx/80 are different
;

;// CONCATENATED MODULE: ./src/ui/header.tsx

var Header = function(param) {
    var children = param.children, _className = param.className, className = _className === void 0 ? "" : _className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
        className: "m-auto w-[80%] font-tucker-tub text-4xl font-bold uppercase lg:text-header ".concat(className),
        children: children
    });
};

;// CONCATENATED MODULE: ./src/ui/heroText.tsx

var HeroText = function(param) {
    var children = param.children, _className = param.className, className = _className === void 0 ? "" : _className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "w-full text-base lg:w-3/5 ".concat(className),
        children: children
    });
};

;// CONCATENATED MODULE: ./src/ui/image-wrapper.tsx

var ImageWrapper = function(param) {
    var children = param.children, _className = param.className, className = _className === void 0 ? "" : _className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "relative aspect-1 rounded-xl shadow-ecPrimary-4 ".concat(className),
        children: children
    });
};

;// CONCATENATED MODULE: ./src/ui/textBold.tsx

var TextBold = function(param) {
    var children = param.children, _className = param.className, className = _className === void 0 ? "" : _className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
        className: "w-full font-haboro-soft text-base font-bold ".concat(className),
        children: children
    });
};

;// CONCATENATED MODULE: ./src/ui/title.tsx

var Title = function(param) {
    var children = param.children, _className = param.className, className = _className === void 0 ? "" : _className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
        className: "text-list font-bold lg:text-title ".concat(className),
        children: children
    });
};

;// CONCATENATED MODULE: ./src/ui/infoCard.tsx



var InfoCard = function(param) {
    var cardData = param.cardData;
    var heading = cardData.heading, subheading = cardData.subheading, description = cardData.description, Icon = cardData.icon, _className = cardData.className, className = _className === void 0 ? "" : _className;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "space-y-5 rounded-lg bg-colorFifteen/10 px-8 py-12 font-haboro-soft text-colorFifteen transition duration-300 ease-in-out hover:-translate-y-2 hover:bg-colorFifteen/[0.12] ".concat(className),
        children: [
            Icon,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                children: heading
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextBold, {
                children: subheading
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-full font-haboro-soft text-base",
                children: description
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/ui/text.tsx

var Text = function(param) {
    var children = param.children, _className = param.className, className = _className === void 0 ? "" : _className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
        className: "w-full font-haboro-soft text-base ".concat(className),
        children: children
    });
};

;// CONCATENATED MODULE: ./src/ui/wrapper.tsx

var Wrapper = function(param) {
    var children = param.children, _className = param.className, className = _className === void 0 ? "" : _className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat(className.length ? className : "m-auto w-[90%] lg:w-[80%] "),
        children: children
    });
};

// EXTERNAL MODULE: ./node_modules/@heroicons/react/solid/esm/CheckIcon.js
var CheckIcon = __webpack_require__(8057);
;// CONCATENATED MODULE: ./src/ui/apply-button.tsx

/* eslint-disable react/jsx-no-useless-fragment */ /* eslint-disable react/button-has-type */ 

var ApplyButton = function(param) {
    var children = param.children, href = param.href, onClick = param.onClick, _center = param.center, center = _center === void 0 ? false : _center, _className = param.className, className = _className === void 0 ? "" : _className, _containerSpanFull = param.containerSpanFull, containerSpanFull = _containerSpanFull === void 0 ? false : _containerSpanFull, _buttonVariant = param.buttonVariant, buttonVariant = _buttonVariant === void 0 ? "primary" : _buttonVariant, _buttonType = param.buttonType, buttonType = _buttonType === void 0 ? "button" : _buttonType, _disabled = param.disabled, disabled = _disabled === void 0 ? false : _disabled, _fullWidth = param.fullWidth, fullWidth = _fullWidth === void 0 ? false : _fullWidth;
    var backgroundColor = {
        primary: "rgba(203, 153, 114, 1)",
        secondary: "transparent",
        tertiary: "rgba(255, 247, 240, 1)",
        fourth: "rgba(1, 64, 50, 1)",
        fifth: "rgba(178, 169, 174, 1)"
    };
    var color = {
        primary: "rgba(255, 247, 240, 1)",
        secondary: "rgba(1, 64, 50, 1)",
        tertiary: "rgba(1, 64, 50, 1)",
        fourth: "rgba(255, 247, 240, 1)",
        fifth: "rgba(255, 247, 240, 1)"
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "w-full",
        style: {
            gridColumn: containerSpanFull ? "1/-1" : "auto",
            textAlign: center ? "center" : "left"
        },
        children: href ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
            href: href,
            className: "w-full py-4 text-left",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                onClick: onClick,
                type: buttonType,
                disabled: disabled,
                className: "flex items-center justify-between gap-2 rounded-lg py-4 px-6 text-lg font-bold ".concat(className),
                // TODO: these styles could reference from var css variables
                style: {
                    backgroundColor: backgroundColor[buttonVariant],
                    color: color[buttonVariant],
                    margin: center ? "auto" : "0",
                    width: fullWidth ? "100%" : "auto",
                    gap: "1rem"
                },
                children: [
                    children,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckIcon/* default */.Z, {
                        width: "30px"
                    })
                ]
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
            onClick: onClick,
            type: buttonType,
            disabled: disabled,
            className: "flex items-center justify-between gap-2 rounded-lg py-3 px-4 text-lg font-bold ".concat(className),
            // TODO: these styles could reference from var css variables
            style: {
                backgroundColor: backgroundColor[buttonVariant],
                color: color[buttonVariant],
                margin: center ? "auto" : "0",
                width: fullWidth ? "100%" : "auto",
                gap: "1rem"
            },
            children: [
                children,
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckIcon/* default */.Z, {
                    width: "30px"
                })
            ]
        })
    });
} // export const ButtonWithArrowRef = forwardRef<HTMLDivElement, ButtonWithArrowProps>((props, ref) => {
 //   return <ButtonWithArrow {...props} ref={ref} />
 // })
 // ButtonWithArrowRef.displayName = 'ButtonWithArrowRef'
;

// EXTERNAL MODULE: ./src/components/common/index.ts + 9 modules
var common = __webpack_require__(108);
;// CONCATENATED MODULE: ./src/ui/page-container.tsx



var PageContainer = function(props) {
    var children = props.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Layout */.Ar, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "w-full min-h-inherit bg-colorFifteen",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
                className: "m-auto w-[80%] pt-5 pb-8",
                children: children
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/ui/index.ts


















/***/ })

}]);